module.exports = __webpack_public_path__ + "img/android.aa5fdc8b.png";